import {Component, input} from '@angular/core';

/**
 * Page container below the header: centered column with the design padding and 20px between blocks.
 * Widths (including the 24px side padding) as in the designs: `narrow` 1120px (forms), `medium` 1200px
 * (form with a side column, leave), `default` 1280px (overviews), `wide` 1440px (time registration),
 * `full` the whole window (daily, weekly).
 */
@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styles: `
        :host {
            // Read by the sticky save bar to reach the page edges
            --ui-page-pad-x: 24px;
            --ui-page-pad-bottom: 60px;
            display: flex;
            flex-direction: column;
            gap: 20px;
            width: 100%;
            max-width: 1280px;
            margin: 0 auto;
            padding: 20px var(--ui-page-pad-x) var(--ui-page-pad-bottom);
            box-sizing: border-box;
        }

        :host(.narrow) {
            max-width: 1120px;
        }

        :host(.medium) {
            max-width: 1200px;
        }

        :host(.wide) {
            max-width: 1440px;
        }

        :host(.full) {
            max-width: none;
        }

        @media (max-width: 575px) {
            :host {
                --ui-page-pad-x: 16px;
                --ui-page-pad-bottom: 48px;
                padding-top: 16px;
            }
        }
    `,
    host: {
        '[class]': 'size()'
    }
})
export class PageComponent {
    readonly size = input<'narrow' | 'medium' | 'default' | 'wide' | 'full'>('default');
}
